/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:no-submodule-imports no-import-side-effect no-duplicate-imports

import 'tinymce';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/code';
import 'tinymce/plugins/contextmenu';
import 'tinymce/plugins/link';
import 'tinymce/plugins/noneditable';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/autoresize';
import 'tinymce/themes/mobile';
import 'tinymce/themes/silver';
import './plugins/proofreader/plugin';
import './plugins/upload-image/plugin';
import './plugins/simple-paste/plugin';
